import qsRequest from "@/api/qsRequest";

export async function getMenuNavs() {
    const res = await qsRequest({
        method: "get",
        url: "/nav"
    })
    const {data} = res.data
    return {
        navs: data
    }
}